<template>
  <div>
    <v-container >
        <v-row class="elevation-1">
        <v-col>
          <v-select id="input-text-size"
          class="input-text-size"
            v-model="reportConfig"
            :items="reports"
            item-text="description"
            item-value="config"
            label="Type of report"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showDateRange')">
        <v-col cols="6">
              <ClarionDateControl
                :isRequired="true"
                label="From Date"
                v-model="criteria.fromDate"
                :isToggle="false"
              />
        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            :isRequired="true"
            label="To Date"
            v-model="criteria.toDate"
            :isToggle="false"
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        >
        <v-col cols="6"
        v-if="showReportConfig('showTreasurerDate')"
          id="tmc-apportionment-report-from-date">
              <ClarionDateControl
                :isRequired="true"
                label="Treasurer Date"
                v-model="criteria.treasurerDate"
                :isToggle="false"
              />
        </v-col>
        <v-col cols="6"
        v-if="showReportConfig('showClerkDate')"
          id="tmc-apportionment-report-to-date"
        >
          <ClarionDateControl
            :isRequired="true"
            label="Clerk Date"
            v-model="criteria.clerkDate"
            :isToggle="false"
          />
        </v-col>
        <v-col cols="6"
        v-if="showReportConfig('showExciseBoardDate')"
          id="tmc-apportionment-report-to-date"
        >
          <ClarionDateControl
            :isRequired="true"
            label="Excise Board Date"
            v-model="criteria.exciseBoardDate"
            :isToggle="false"
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1">
        <v-col cols="4"
          id="tmc-apportionment-report-fiscalyear"
          v-if="showReportConfig('showFiscalYear')">
          <CommonDropDowns
          :isItFiscalYear=true
          @change="dataFromCommonDropDowns"
          :isFiscalYearWithoutAllYears=true
          />
        </v-col>
        <v-col cols="6"
          id="tmc-apportionment-report-fund"
          v-if="showReportConfig('showFunds')">
          <MultiItemSelect
            id="tmc-apportionment-by-fund"
            label="By Fund"
            item-text="fundDesc"
            item-value="fund"
            :item-list="funds"
            :items="criteria.fundList"
            @selected-items="selectedFundList"
          />
        </v-col>
        <v-col cols="4"
          id="tmc-apportionment-report-fund"
          v-if="showReportConfig('showTaxUnits')">
          <MultiItemSelect
            id="tmc-apportionment-by-taxUnit"
            label="By Tax Unit"
            item-text="toUnitDesc"
            item-value="toUnitDescForAppro"
            :item-list="taxUnitList"
            :items="criteria.taxUnitList"
            @selected-items="selectedTaxUnitList"
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1">
        <v-col cols="6"
          id="tmc-misc-report-print-details"
          v-if="showReportConfig('showTrialRecord')">
          <v-checkbox
            v-model="criteria.printTrialRecord"
            label="Print Trial Records">
          </v-checkbox>
        </v-col>
        <v-col cols="6"
          id="tmc-misc-report-print-details"
          v-if="showReportConfig('showSpecialApportionments')">
          <v-checkbox
            v-model="criteria.isIncludeSA"
            label="Include Special Apportionments">
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <ReportChip
          :to="reportConfig.route"
          :queryString="queryString"
          :isValid="validateCriteria"
          caption="View Report"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
} from 'vuex';
import { reportList, queryStringCalc } from './report-util';
import ReportChip from '../../common/base/report/ReportChip.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { toFiscalYear, toShortDate } from '../../../util/shared/tmc-global';
import { getRawJwt } from '../../../util/jwt';
import CommonDropDowns from '../../tax/common-utils/CommonDropDowns.mixin.vue';
// import SimpleMultiSelect from '../../common/base/SimpleMultiSelect.vue';
import MultiItemSelect from '../../common/base/MultiItemSelect.vue';

const fundCrudKey = 'sharedFund';
const taxUnitCurdKey = 'sharedTaxUnit';
export default {
  name: 'ApportionmentReportComp',
  components: {
    ReportChip,
    ClarionDateControl,
    CommonDropDowns,
    // SimpleMultiSelect,
    MultiItemSelect,
  },
  data: () => ({
    criteria: {
      fy: {},
      fromDate: undefined,
      toDate: undefined,
      treasurerDate: undefined,
      clerkDate: undefined,
      exciseBoardDate: undefined,
      printTrialRecord: false,
      isIncludeSA: false,
      fiscalYear: undefined,
      fundList: [],
      taxUnitList: [],

    },
    reportConfig: {
      route: '',
      filters: {},
    },
    criteriaStats: {
      allFunds: false,
      allTaxUnits: false,
    },
    defaultCriteria: {
      fy: undefined,
    },
  }),
  created() {
    this.initCriteria();
  },
  computed: {
    ...mapGetters('base/crud', ['items']),
    ...mapGetters(['todaysDate']),
    reports() {
      return [
        ...reportList(),
      ];
    },
    funds() {
      const fundObjs = this.items(fundCrudKey) || [];
      const updatedFundObj = fundObjs.map((f) => ({
        ...f,
        fundDesc: f.fund === '0000' ? f.description : `${f.fund} - ${f.description || ''}`,
      }));
      return [...updatedFundObj]; // { _id: null, fund: '', fundDesc: '' },
    },
    taxUnitList() {
      const taxUnitObjs = this.items(taxUnitCurdKey) || [];
      const updatedtaxUnitObj = taxUnitObjs.map((f) => ({
        ...f,
        toUnitDesc: `${f.toUnitDescForAppro || ''}  ${f.description || ''}`,
      }));
      return [...updatedtaxUnitObj]; // { _id: null, fund: '', fundDesc: '' },
    },
    queryString() {
      return queryStringCalc({
        reportConfig: this.reportConfig,
        criteria: this.criteria,
        token: this.getAuthToken,
        defaultCriteria: this.defaultCriteria,
        devSetting: this.devSettingItem,
        criteriaStats: this.criteriaStats,
      });
    },
    validateCriteria() {
      let isValid = true;
      if (this.criteria.fy == null) {
        isValid = false;
      }
      return isValid;
    },
    getAuthToken() {
      return getRawJwt();
    },
  },
  methods: {
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions('shared/taxUnit', [
      'loadTaxUnit',
    ]),
    mapCollectionVal(itemList, itemValue) {
      return [...(itemList || []).map((item) => item[`${itemValue}`])];
    },
    loadFundList(fy) {
      this.loadFunds({
        criteria: {
          fiscalYear: fy || 0,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: fundCrudKey,
      }).then(() => {
        this.criteria.fundList = this.mapCollectionVal(this.funds, 'fund');
        /* Set select-all */
        this.criteriaStats.allFunds = true;
      });
    },
    loadTaxUnitList(fy) {
      this.loadTaxUnit({
        criteria: {
          fiscalYear: fy || 0,
        },
        baseCrudKey: taxUnitCurdKey,
      }).then(() => {
        this.criteria.taxUnitList = this.mapCollectionVal(this.taxUnitList, 'toUnitDescForAppro');
        /* Set select-all */
        this.criteriaStats.allTaxUnits = true;
      });
    },
    showReportConfig(configField) {
      return this.reportConfig.filters[`${configField}`];
    },
    initCriteria() {
      this.criteria.fromDate = toShortDate(this.todaysDate);
      this.criteria.toDate = toShortDate(this.todaysDate);
      this.criteria.treasurerDate = toShortDate(this.todaysDate);
      this.criteria.clerkDate = toShortDate(this.todaysDate);
      this.criteria.exciseBoardDate = toShortDate(this.todaysDate);
      this.criteria.fiscalYear = toFiscalYear(new Date(this.todaysDate));
      this.loadFundList(this.criteria.fiscalYear);
      this.loadTaxUnitList(this.criteria.fiscalYear);
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteria[whichField] = val;
      this.loadFundList(val);
      this.loadTaxUnitList(val);
    },
    selectedFundList(val) {
      this.criteria.fundList = val;
      const val2 = (val || []).length === this.funds.length;
      this.criteriaStats.allFunds = val2;
    },
    selectedTaxUnitList(val) {
      this.criteria.taxUnitList = val;
      const val2 = (val || []).length === this.taxUnitList.length;
      this.criteriaStats.allTaxUnits = val2;
    },
  },
};

</script>
